
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
              EULA VC
            </h3>
            <p className="text-slate-300 mb-4 max-w-md">
              We fund Europe's boldest founders — and help them conquer LATAM.
            </p>
            <p className="text-slate-400 text-sm">
              Luxembourg-based venture capital firm bridging Europe and Latin America through strategic seed investments.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors cursor-pointer">About</Link></li>
              <li><Link to="/investment-thesis" className="text-slate-300 hover:text-white transition-colors cursor-pointer">Investment Thesis</Link></li>
              <li><Link to="/portfolio" className="text-slate-300 hover:text-white transition-colors cursor-pointer">Portfolio</Link></li>
              <li><Link to="/apply" className="text-slate-300 hover:text-white transition-colors cursor-pointer">Apply for Funding</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-slate-300">
              <li className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                Luxembourg City, Luxembourg
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                eu.la.vccompany@gmail.com
              </li>
              <li className="flex items-center">
                <i className="ri-linkedin-line mr-2"></i>
                LinkedIn
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm">
            © 2024 EULA VC. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-slate-400 hover:text-white text-sm transition-colors cursor-pointer mt-2 md:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
